import React, { useState, useEffect } from "react";
import { useFormFields } from "../libs/hooksLib";
import { Auth, API } from "aws-amplify";
import "../config";
import "./Profil.css";

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';

import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import ModalButton from "../components/ModalButton";
import TextFieldFullWidth from "../components/TextFieldFullWidth";

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/da';

import AutoRefresh from '../components/AutoRefresh';
import LoadingWrapper from '../components/LoadingWrapper';
import { useSnackbar } from 'notistack';
import { Forum } from "@material-ui/icons";
import { useContainerStyles } from '../styles/commonStyles';


const useStyles = makeStyles(theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  control: {
    padding: theme.spacing(2),
  },
  details: {
    alignItems: 'start',
  },
  columnHelp: {
    flexBasis: '33.33%',
  },
  columnForm: {
    flexBasis: '66.66%',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

export default function Profil(props) {
  const containerClasses = useContainerStyles();
  const classes = useStyles();
  dayjs.extend(utc);
  const initialState = {
    vendor_alias: "",
    contact_name: "",
    contact_mail: "",
    contact_phone: "",
    vendor_cvr: "",
    response_valid_days: "60",
    send_complete_mail: true,
    send_aktoer_mail: false,
    check_ler_start: '00:00:00+00:00',
    check_ler_end: '23:59:59+00:00',
    response_expected_days: "5",
    svar_aktoer_valgfri_tekst: "",
    paavis_contact_mail: "",
    data_contact_mail: "",
  }

  const [isLoading, setIsLoading] = useState(false);
  const [formCreateMode, setFormCreateMode] = useState(false);
  const [fields, setValues, handleFieldChange] = useFormFields(initialState);
  const [timeStart, setTimeStart] = useState(dayjs.utc('2024-12-12T' + initialState.check_ler_start));
  const [timeEnd, setTimeEnd] = useState(dayjs.utc('2024-12-12T' + initialState.check_ler_end));
  const [error, setError] = useState('');

  // Snackbar
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  // Handle expansions
  const [expanded, setExpanded] = useState("panel1");
  const handleExpansionChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // Handle validation
  function validateForm() {
    // return fields.vendor_alias.length > 0 && fields.vendor_cvr.length > 0;
    return true
  }

  // Run on vendorID change
  useEffect(() => {
    //console.log('vendorMeta change i profil')
    //console.table(props.vendorMeta)
    setIsLoading(true);
    if (props.isAdmin) {
      if (props.vendorID === '') {
        setFormCreateMode(true)
      } else {
        setFormCreateMode(false)
      }
    }
    if (props.vendorMeta && Object.keys(props.vendorMeta).length > 0 ) {
      setValues({ ...initialState, ...props.vendorMeta })
      setTimeStart(dayjs.utc('2024-12-12T' + props.vendorMeta.check_ler_start))
      setTimeEnd(dayjs.utc('2024-12-12T' + props.vendorMeta.check_ler_end))
    } else {
      setValues(initialState)
      setTimeStart(dayjs.utc('2024-12-12T' + initialState.check_ler_start))
      setTimeEnd(dayjs.utc('2024-12-12T' + initialState.check_ler_end))
    }
    setIsLoading(false)
  }, [props.vendorMeta]);

  useEffect(() => {
    checkTime()
  }, [timeStart, timeEnd]);

  function vendorDelete() {
    deleteVendor(props.vendorID).then(function () {
      props.setVendorID('');
    })
  }
  function getUTCtimeString(date) {
    const newDate = new Date(date)
    return `${newDate.getUTCHours().toString().padStart(2, '0')}:${newDate.getMinutes().toString().padStart(2, '0')}:${newDate.getSeconds().toString().padStart(2, '0')}+00:00` 	
  }
  async function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);

    let body = fields;
    if (timeStart) {
      body.check_ler_start = getUTCtimeString(timeStart)
    }
    if (timeEnd) {
      body.check_ler_end = getUTCtimeString(timeEnd)
    }
    await upsertVendor({ body })
      .then(response => enqueueSnackbar('Gemt', { variant: 'success', }))
      .catch(response => enqueueSnackbar('Kunne ikke gemme: ' + response, { variant: 'error', }))
      .finally(f => {
        setIsLoading(false)
        props.setVendorID(props.vendorID)
      })

  }
  // endpoints
  async function deleteVendor(id) {
    let init = {
      headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
    }
    return await API.del("API", "/Vendor/" + id, init);
  }
  async function upsertVendor(values) {
    values["headers"] = { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
    if (formCreateMode) {
      return await API.post("API", "/Vendor", values);
    } else {
      return await API.put("API", "/Vendor/" + props.vendorID, values);
    }
  }
  function checkTime() {
    if (!timeStart || !timeEnd) return;
    
    const startTime = timeStart.year(2024).month(11).date(12); 
    const endTime = timeEnd.year(2024).month(11).date(12); 
    
    //console.log(startTime.toString() + " -> " + endTime.toString() )
    if (startTime > endTime) {
      setError('Slut tid skal være senere end Start tid.');
    } else {
      setError('');
    }
  }
  
  async function refresh() {
    if (props.vendorMeta && Object.keys(props.vendorMeta).length > 0) {
      setValues({ ...initialState, ...props.vendorMeta });
      setTimeStart(dayjs.utc('2024-12-12T' + props.vendorMeta.check_ler_start))
      setTimeEnd(dayjs.utc('2024-12-12T' + props.vendorMeta.check_ler_end))
    } else {
      setValues(initialState);
      setTimeStart(dayjs.utc('2024-12-12T' + initialState.check_ler_start))
      setTimeEnd(dayjs.utc('2024-12-12T' + initialState.check_ler_end))
    }
  }
  return (
    <div className={containerClasses.root}>
      <AutoRefresh onRefresh={refresh} disableAuto={true} disabled={!props.vendorMeta || Object.keys(props.vendorMeta).length === 0} />
      <LoadingWrapper isLoading={isLoading}>
      <form noValidate autoComplete="off" onSubmit={handleSubmit} key={formCreateMode}>
        <Grid
          container
          spacing={4}
          direction="column"
          //alignItems="flex-start"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <Accordion expanded={expanded === 'panel1'} onChange={handleExpansionChange('panel1')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography className={classes.heading}>Kontakt</Typography>
                <Typography className={classes.secondaryHeading}>Generelle information</Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.details}>
                <div className={classes.columnHelp}>
                  <Typography variant="body2" gutterBottom>
                    Oplysninger omkring ledningsejer og kontaktpersoner der skal bruges i forbindelse med graveforespørgsler.
                  </Typography>
                </div>
                <div className={classes.columnForm}>
                  <TextFieldFullWidth
                    id="vendor_alias"
                    label="Ledningsejernavn"
                    placeholder="AMBA amba."
                    helperText="Fritekst"
                    value={fields.vendor_alias}
                    onChange={handleFieldChange}
                    isLoading={isLoading}
                  />
                  <TextFieldFullWidth
                    id="vendor_cvr"
                    label="CVR-nummer"
                    placeholder="12345678"
                    helperText="Bruges til data fra CVR"
                    value={fields.vendor_cvr}
                    onChange={handleFieldChange}
                    isLoading={isLoading}
                  />
                  <TextFieldFullWidth
                    id="contact_name"
                    label="Kontakt - Navn"
                    placeholder="Jens J. Jensen"
                    helperText="Bruges til at angive telefonnummer kontakt for tekniske spørgsmål i graveforespørgsel"
                    value={fields.contact_name}
                    onChange={handleFieldChange}
                    isLoading={isLoading}
                  />
                  <TextFieldFullWidth
                    id="contact_mail"
                    label="Kontakt - Mail"
                    placeholder="jjj@AMBA.dk"
                    helperText="Bruges til at angive telefonnummer mail-adresse for tekniske spørgsmål i graveforespørgsel. Flere modtagere adskilles med ;, men kun den første vil blive vist i svaret til LER."
                    value={fields.contact_mail}
                    onChange={handleFieldChange}
                    isLoading={isLoading}
                  />
                  <TextFieldFullWidth
                    id="contact_phone"
                    label="Kontakt - Telefon"
                    placeholder="12 34 56 78"
                    helperText="Bruges til at angive telefonnummer for tekniske spørgsmål i graveforespørgsel"
                    value={fields.contact_phone}
                    onChange={handleFieldChange}
                    isLoading={isLoading}
                  />
                  <TextFieldFullWidth
                    type="number"
                    id="svar_aktoer_valgfri_tekst"
                    label="Supplerende information til graveaktør"
                    placeholder=""
                    multiline
                    minRows={8}
                    helperText="Valgfri tekst der bliver sendt med graveforespørgslen som supplerende tekst."
                    value={fields.svar_aktoer_valgfri_tekst}
                    onChange={handleFieldChange}
                    isLoading={isLoading}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel2'} onChange={handleExpansionChange('panel2')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2bh-content"
                id="panel2bh-header"
              >
                <Typography className={classes.heading}>System</Typography>
                <Typography className={classes.secondaryHeading}>Systemindstillinger</Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.details}>
                <div className={classes.columnHelp}>
                  <Typography variant="body2" gutterBottom>
                    Disse systemindstillinger er med til at bestemme hvordan LER assistenten håndterer denne profil.
                  </Typography>
                </div>
                <div className={classes.columnForm}>
                  <div>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="da">
                      <TimePicker
                        onChange={(newValue) => setTimeStart(newValue) }
                        value={ timeStart }
                        placeholder="00:00:00"
                        label="Start tid for LER tjek"
                        format="HH:mm:ss"
                        helperText="Angiv tidsrum for hvornår på dagen vi skal starte med at tjekke LER for nye forespørgsler."
                        slotProps={{ textField: { style: { maxWidth: '145px', minWidth: '145px' } } }}
                      />&nbsp;
                      <TimePicker
                        onChange={(newValue) => setTimeEnd(newValue)}
                        value={ timeEnd }
                        label="Slut tid for LER tjek"
                        format="HH:mm:ss" 
                        helperText="Angiv tidsrum for hvornår på dagen vi skal stoppe med at tjekke LER for nye forespørgsler."
                        slotProps={{ textField: { style: { maxWidth: '145px', minWidth: '145px' } } }}
                      />
                    </LocalizationProvider>
                    {error && <div style={{ color: 'red' }}>{error}</div>}
                  </div>
                  <TextFieldFullWidth
                    type="number"
                    id="response_valid_days"
                    label="Forældelse"
                    placeholder="60"
                    helperText="Antal dage ledningsinformationer angives til at være gyldige. Det er graveaktørens ansvar at indhente opdaterede oplysninger. Denne information sendes med ud til LER."
                    value={fields.response_valid_days}
                    onChange={handleFieldChange}
                    isLoading={isLoading}
                  />
                  <TextFieldFullWidth
                    type="number"
                    id="response_expected_days"
                    label="Svarfrist"
                    placeholder="5"
                    helperText="Antal forventede dage inden svar på manuel håndtering af graveforespørgsel. Denne information sendes med ud til LER."
                    value={fields.response_expected_days}
                    onChange={handleFieldChange}
                    isLoading={isLoading}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
                        <Accordion expanded={expanded === 'panel3'} onChange={handleExpansionChange('panel3')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3bh-content"
                id="panel3bh-header"
              >
                <Typography className={classes.heading}>Notifikationer</Typography>
                <Typography className={classes.secondaryHeading}>Beskedindstillinger</Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.details}>
                <div className={classes.columnHelp}>
                  <Typography variant="body2" gutterBottom>
                    Disse systemindstillinger er med til at bestemme hvordan LER assistenten håndterer denne profil.
                  </Typography>
                </div>
                <div className={classes.columnForm}>
                  <FormControlLabel
                    value={fields.send_complete_mail}
                    control={<Checkbox id="send_complete_mail" size="medium" checked={fields.send_complete_mail} value={fields.send_complete_mail} onChange={handleFieldChange} color="primary" />}
                    label="Send en mail når graveforespørgsel er besvaret"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value={fields.send_aktoer_mail}
                    control={<Checkbox id="send_aktoer_mail" size="medium" checked={fields.send_aktoer_mail} value={fields.send_aktoer_mail} onChange={handleFieldChange} color="primary" />}
                    label="Send en mail til graveaktøren når graveforespørgsel er besvaret"
                    labelPlacement="end"
                  />
                  <TextFieldFullWidth
                    id="paavis_contact_mail"
                    label="Kontakt - Påvisningsansvarlig"
                    placeholder="jjj@AMBA.dk"
                    helperText="Hvis denne er udfyldt vil notifikationer omkring påvisning blive sendt til denne mail. Flere modtagere adskilles med ;"
                    value={fields.paavis_contact_mail}
                    onChange={handleFieldChange}
                    isLoading={isLoading}
                  />
                  <TextFieldFullWidth
                    id="data_contact_mail"
                    label="Kontakt - Dataansvarlig"
                    placeholder="jjj@AMBA.dk"
                    helperText="Hvis denne er udfyldt vil notifikationer omkring manuel håndtering blive sendt til denne mail. Flere modtagere adskilles med ;"
                    value={fields.data_contact_mail}
                    onChange={handleFieldChange}
                    isLoading={isLoading}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  style={{ left: "auto" }}
                  type="submit"
                  disabled={isLoading || error}
                >
                  {formCreateMode ? "Tilføj profil" : "Gem profil"}
                </Button>
              </Grid>
              {props.isAdmin &&
                <>
                  <Grid item>
                    <ModalButton
                      disabled={formCreateMode}
                      btnText="Slet profil"
                      btnVariant="contained"
                      btnColor="secondary"
                      acceptAction={vendorDelete}
                      acceptText="slet"
                      cancelText="fortryd"
                      titleText={"Bekræft sletning af profil"}
                      contentText={"Denne handling fjerner den aktive profil ude yderligere varsel."}
                    />
                  </Grid>
                  <Grid item>
                    <Button
                      disabled
                      color="primary"
                      variant="contained"
                      style={{ left: "auto" }}
                    >
                      Tildel fjernadgang
                    </Button>
                  </Grid>
                </>
              }
            </Grid>
          </Grid>
        </Grid>
      </form>
      </LoadingWrapper>
    </div>
  );
}
